import { styled } from "styled-components";

export const Container = styled.div``

export const MainContainer = styled.main``

export const TaskContainer = styled.div`
  max-width: 600px;
  margin: auto;

  h1 {
    text-align: center;
  }
`